import { render, staticRenderFns } from "./AddGroupDialog.vue?vue&type=template&id=a5029760&scoped=true"
import script from "./AddGroupDialog.vue?vue&type=script&lang=js"
export * from "./AddGroupDialog.vue?vue&type=script&lang=js"
import style0 from "./AddGroupDialog.vue?vue&type=style&index=0&id=a5029760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5029760",
  null
  
)

export default component.exports